import React, { useContext, useState } from 'react'
import styles from './styles.module.css'
import Button from '../../../../components/Button'
import { GroupsDoVdContext } from '../../../../utils/context'
import Table from '../../../../components/Table'
import { BiTrash, BiEdit } from 'react-icons/bi'
import Empty from '../../../../components/Empty'
import Modal from 'react-responsive-modal'
import { Select } from '../../../../components/ModalInputs'

export default function TermTypes() {
    const { formik, schoolYears, termTypes, onDeleteTermType, onUpdateTermType } = useContext(GroupsDoVdContext);
    const { values } = formik;

    const [isShowModal, setIsShowModal] = useState(false);
    const [editingItem, setEditingItem] = useState(null); // null = добавление, object = редактирование
    const [formData, setFormData] = useState({
        term_type_id: '',
        s_year_id: ''
    });

    const openAddModal = () => {
        setEditingItem(null);
        setFormData({ term_type_id: '', s_year_id: '' });
        setIsShowModal(true);
    };

    const openEditModal = (item) => {
        setEditingItem(item);
        setFormData({
            term_type_id: item.term_type_id?.toString() || '',
            s_year_id: (item.s_year_id || item.school_year_key)?.toString() || ''
        });
        setIsShowModal(true);
    };

    const closeModal = () => {
        setIsShowModal(false);
        setEditingItem(null);
        setFormData({ term_type_id: '', s_year_id: '' });
    };

    const handleSave = () => {
        if (!formData.term_type_id || !formData.s_year_id) return;

        const selectedTermType = termTypes?.find(t => t.term_type_id === Number(formData.term_type_id));
        const selectedYear = schoolYears?.find(y => y.xp_key === Number(formData.s_year_id));

        if (editingItem) {
            // Редактирование
            const updatedItem = {
                ...editingItem,
                term_type_id: Number(formData.term_type_id),
                term_type_name: selectedTermType?.term_type_name || '',
                s_year_id: Number(formData.s_year_id),
                school_year_key: Number(formData.s_year_id),
                school_year_name: selectedYear?.name || '',
                isEdited: true // флаг для отслеживания изменений
            };

            // Если это серверный элемент - добавляем в список на обновление
            if (editingItem.xp_group_tt_id) {
                onUpdateTermType(updatedItem);
            }

            // Обновляем локально
            const updatedTermTypes = values.term_types?.map(t =>
                (t.id || t.xp_group_tt_id) === (editingItem.id || editingItem.xp_group_tt_id) ? updatedItem : t
            );
            formik.setFieldValue('term_types', updatedTermTypes);
        } else {
            // Добавление
            const newItem = {
                id: Date.now(),
                term_type_id: Number(formData.term_type_id),
                term_type_name: selectedTermType?.term_type_name || '',
                s_year_id: Number(formData.s_year_id),
                school_year_name: selectedYear?.name || ''
            };
            const currentTermTypes = values.term_types || [];
            formik.setFieldValue('term_types', [...currentTermTypes, newItem]);
        }

        closeModal();
    };

    const handleDeleteTermType = (item) => {
        const itemId = item.id || item.xp_group_tt_id;

        // Если это серверный элемент - добавляем в список на удаление
        if (item.xp_group_tt_id) {
            onDeleteTermType(item.xp_group_tt_id);
        }

        // Удаляем локально из списка
        const newTermTypes = values.term_types?.filter(t => (t.id || t.xp_group_tt_id) !== itemId);
        formik.setFieldValue('term_types', newTermTypes);
    };

    const renderRow = (data) => {
        const { id: termId, xp_group_tt_id, term_type_name, school_year_name } = data;
        const itemId = termId || xp_group_tt_id;
        return (
            <tr key={itemId} onClick={() => openEditModal(data)} style={{ cursor: 'pointer' }}>
                <td>{term_type_name}</td>
                <td>{school_year_name}</td>
                <td onClick={(e) => e.stopPropagation()}>
                    <div style={{ display: 'flex', gap: '0.5rem' }}>
                        <i
                            className={styles.edit}
                            onClick={() => openEditModal(data)}
                        >
                            <BiEdit />
                        </i>
                        <i
                            className={styles.trash}
                            onClick={() => handleDeleteTermType(data)}
                        >
                            <BiTrash />
                        </i>
                    </div>
                </td>
            </tr>
        );
    };

    return (
        <>
            <div className={styles.modalMain}>
                <div className={styles.tabWrapper}>
                    <div className={styles.buttons}>
                        <Button onClick={openAddModal}>
                            Добавить
                        </Button>
                    </div>

                    {values?.term_types?.length > 0 ? (
                        <div className={styles.tableWrapper}>
                            <Table className={styles.table}>
                                <thead>
                                    <tr>
                                        <th>Тип уч. периода</th>
                                        <th>Учебный год</th>
                                        <th width={'3rem'}>Действия</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {values.term_types.map(renderRow)}
                                </tbody>
                            </Table>
                        </div>
                    ) : (
                        <Empty text='Типы уч. периодов не добавлены' />
                    )}
                </div>
            </div>

            <Modal
                open={isShowModal}
                onClose={closeModal}
                center
                closeOnOverlayClick={false}
            >
                <div style={{ padding: '2rem', minWidth: '400px' }}>
                    <h3 style={{ marginBottom: '1rem', color: '#274684' }}>
                        {editingItem ? 'Редактировать тип уч. периода' : 'Добавить тип уч. периода'}
                    </h3>

                    <div style={{ marginBottom: '1rem' }}>
                        <Select
                            label='Тип уч. периода'
                            value={formData.term_type_id}
                            onChange={(e) => setFormData({ ...formData, term_type_id: e.target.value })}
                        >
                            <option value=''>Выберите тип</option>
                            {termTypes?.map((el) => (
                                <option key={el.term_type_id} value={el.term_type_id}>
                                    {el.term_type_name}
                                </option>
                            ))}
                        </Select>
                    </div>

                    <div style={{ marginBottom: '1.5rem' }}>
                        <Select
                            label='Учебный год'
                            value={formData.s_year_id}
                            onChange={(e) => setFormData({ ...formData, s_year_id: e.target.value })}
                        >
                            <option value=''>Выберите год</option>
                            {schoolYears?.map((el) => (
                                <option key={el.xp_key} value={el.xp_key}>
                                    {el.name}
                                </option>
                            ))}
                        </Select>
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '1rem' }}>
                        <Button mode='white' onClick={closeModal}>
                            Отмена
                        </Button>
                        <Button onClick={handleSave}>
                            {editingItem ? 'Сохранить' : 'Добавить'}
                        </Button>
                    </div>
                </div>
            </Modal>
        </>
    );
}
